import React from "react";
import styled from "styled-components";
import { Rate, InsiderPhoto, Name } from "./";
import * as model from "modules/booking/model";
import timeslot from "./assets/timeslot.svg";

export default ({
  title,
  company,
  company: { company: { logo }, title_name },
  display_name,
  group_tag,
  slug,
  time_slot: { time_start },
  call_price,
  id
}) => (
  <Wrap className="pv3-ns pa3 ph4-ns bg-white br2 mb3 items-center tl-ns tc">
    <div className="mb2 db-ns flex justify-center">
      <InsiderPhoto
        insider
        photo={
          logo ||
          "https://storage.googleapis.com/thelobby-public-storage/insiders/photo/TheLobby_Logo-02.jpg"
        }
        alt={display_name || slug}
      />
    </div>
    <div className="flex justify-between tc">
      <Name {...{ display_name, title_name, title, company }} />
      <Rate {...call_price} />
    </div>
    {group_tag && <div style={{ fontSize: "16px" }}>{group_tag.label}</div>}
    <div className="flex mt3 justify-start-ns justify-center">
      <img src={timeslot} className="mr2" alt="timeslot" />
      <TimeWrap className="ml2-ns">{model.formatTime(time_start)}</TimeWrap>
    </div>
  </Wrap>
);

const Wrap = styled.div`
  background-color: #ebe8e1;
  border-top: 8px solid #000000;
  font-size: 21px;
  color: #333333;
  font-family: CircularStd-Book, sans-serif;
  @media (max-width: 680px) {
    border: unset;
    background: #f9f7f2;
  }
`;
const TimeWrap = styled.div`
  font-family: CircularStd-Book, sans-serif;
  font-size: 16px;
  color: #f76367;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/InsiderCard.js